import React from "react";
import {Spin} from "antd";

const Loading = props=>{
    return <Spin {...props} />
}

export default Loading;
